import { render, staticRenderFns } from "./info-icon.vue?vue&type=template&id=de2cf742"
import script from "./info-icon.vue?vue&type=script&lang=js"
export * from "./info-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports